import './styles/main.scss';
import './components';

import lozad from 'lozad';

const observer = lozad(); // lazy loads elements with default selector as ".lozad"
observer.observe();
